import { createSlice } from '@reduxjs/toolkit';

import { COUNTRIES } from '@app/store';
import { COUNTRIES_INITIAL_STATE } from '@app/store/reducers/countriesReducer/countries.state';
import type { NDictionaries } from '@app/types';

import type { PayloadAction } from '@reduxjs/toolkit';

const countriesSlice = createSlice({
  name: COUNTRIES,
  initialState: COUNTRIES_INITIAL_STATE,
  reducers: {
    setCountries: (
      state,
      { payload }: PayloadAction<{ data: NDictionaries.ModelCountry[] }>
    ) => {
      const { data } = payload;

      state.dictionary = data;
    },
  },
});

export const { setCountries } = countriesSlice.actions;
export const countriesReducer = countriesSlice.reducer;
